import styled from '@emotion/styled';
export const StyledContainer = styled.div `
  position: relative;
  height: 100%;
  background: ${({ theme }) => theme.colors.backgrounds.content.background};
  margin: ${({ theme }) => theme.space[2]};
  box-shadow: 0 0 6px rgba(0, 20, 60, 0.0985904);
  white-space: normal;
  ${({ device, cardsCount }) => {
    if (device === 'mobile') {
        return `
      ${cardsCount == 1 // following calculation uses 32px because of various paddings and margins around Carousel
            ? `
        min-width: 262px;
        width: calc(100vw - 32px);
      `
            : ''}
      ${cardsCount > 1
            ? `
        width: 276px;
      `
            : ''}
      `;
    }
    else {
        return `
        ${cardsCount == 1
            ? `
          max-width: 884px;
          min-width: 596px;
          width: calc(100vw - 556px);
        `
            : ''}
        ${cardsCount == 2
            ? `
          max-width: 430px;
          min-width: 276px;
          width: calc(50vw - 290px);
        `
            : ''}
        ${cardsCount > 2
            ? `
          width: 276px;
        `
            : ''}
      `;
    }
}}
`;
export const StyledContent = styled.div `
  background: ${({ theme }) => theme.colors.backgrounds.content.background};
  margin: 0;
  padding: 8px 8px 0 8px;
`;
export const StyledRow = styled.div `
  position: relative;
  display: flex;
  align-items: center;
`;
export const StyledEventName = styled.span `
  flex: 1;
  font-size: 10px;
  line-height: 12px;
  opacity: 0.5;
  color: ${({ theme }) => theme.colors.backgrounds.content.text[0]};
`;
export const StyledEventInfo = styled.span `
  font-size: 10px;
  color: ${({ theme }) => theme.colors.backgrounds.content.text[0]};
  width: 60px;
  text-align: center;
`;
export const StyledContentInfo = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
`;
export const StyledInfoName = styled.p `
  padding: 0 16px 0 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.backgrounds.content.text[0]};
  line-height: 16px;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const StyledContentLabels = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 0;
`;
export const StyledBlurbContainer = styled.div `
  padding: ${({ theme }) => theme.space[2]} 8px;
  div {
    width: 100%;
    line-height: normal;
    text-align: left;
  }
`;
export const StyledBlurb = styled.div `
  color: #7383a6;
  text-align: center;
  display: inline-block;
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
`;
